export default class Hero {

	constructor(element) {
		this.element = element;
		this.bgVideo = this.element ? this.element.querySelector('.gigs-hero__background-video') : null;
	}

	init() {
		this.initBGVideo();
	}

	destroy() {
		this.destroyBGVideo();
	}

	initBGVideo() {
		if (this.bgVideo) {
			const { src, type } = this.bgVideo.dataset;

			if (! src) {
				throw new Error('No src found for the hero BG video', {
					cause: {
						element: this.element,
						video: this.bgVideo
					}
				});
			}

			const video = document.createElement('video');
			video.autoplay = true;
			video.muted = true;
			video.loop = true;
			video.preload = 'metadata';
			video.tabIndex = -1;

			const source = document.createElement('source');
			source.src = src;
			source.type = type;

			video.appendChild(source);

			this.bgVideo.appendChild(video);
		}
	}

	destroyBGVideo() {
		if (this.bgVideo) {
			this.bgVideo.innerHTML = '';
		}
	}
}
